<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar a estante <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(storage_shelf) {
    console.log("to del", storage_shelf);
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_STORAGE_SHELF_MUTATION,
          variables: {
            id: storage_shelf.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyStorageShelf.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_STORAGE_SHELF_MUTATION = gql `
  mutation($id: ID!) {
    destroyStorageShelf(id: $id) {
      storageShelf {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>